export enum BulkMaintenanceScheduleGroupedByField {
  Aircraft = 'Aircraft',
  ClientContract = 'ClientContract',
}
